import { AbstractControl } from '@angular/forms';

export function openingPriceCustomValidator(control: AbstractControl): { [key: string]: boolean } | null {

  if (control.value === 0) {
    return { 0: true };
  }
  return null;
}
